var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.558 0H15.4314C6.91291 0 0 6.75032 0 15.0626V193.959C0 202.283 6.91291 209.042 15.4314 209.042H193.558C202.083 209.042 209.042 202.283 209.042 193.959V15.0626C209.042 6.75032 202.083 0 193.558 0ZM61.9984 178.133H30.9789V78.3763H61.9984V178.133ZM46.4886 64.7363C36.5504 64.7363 28.5168 56.6823 28.5168 46.7528C28.5168 36.8379 36.5504 28.7839 46.4886 28.7839C56.4036 28.7839 64.4575 36.8379 64.4575 46.7528C64.4575 56.6823 56.4036 64.7363 46.4886 64.7363ZM178.121 178.133H147.151V129.624C147.151 118.051 146.925 103.171 131.035 103.171C114.898 103.171 112.439 115.774 112.439 128.784V178.136H81.4451V78.3763H111.19V91.9988H111.614C115.754 84.1598 125.869 75.8881 140.955 75.8881C172.329 75.8881 178.124 96.5426 178.124 123.413L178.121 178.133Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9eac5c6d1258ff3dc1fc40a1e9c8b7c8.svg";
export { ForwardRef as ReactComponent };